// Remove html tags from the string
export function removeHtmlTags(input: string) {
    let element = document.createElement('div')
    element.innerHTML = input
    var text = element.textContent || element.innerText || "";
    return text;
}

// regular expression will now ignore any leading or trailing spaces around the HTML tags 
// while still removing the HTML tags from the input string. 
// It will preserve spaces within the tags and between multiple tags
export function replaceHtmlTags(inputString: string) {
    const pattern = /<(?![^>]*\s)[^>]*>/g;
    return inputString.replace(pattern, '');
}

// Regular expression pattern to check for special characters
// $, +, -, = are not allowed in title
export function hasSpecialCharacters(inputString: string) {
    
    const specialCharactersPattern = /[$*+\-=]/;
  
    // Test the inputString against the pattern
    return specialCharactersPattern.test(inputString);
}